import { axios } from '@/utils/request'
// eslint-disable-next-line
import { UserLayout, BasicLayout, RouteView, BlankLayout, PageView } from '@/layouts'
// import { asyncRouterMap } from '@/config/router.config'
import wxMain from '@/views/wx/index'
import wxCorpBusiness from '@/views/wx/CorpBusiness'
import wxOrderReceipt from '@/views/wx/OrderReceipt'
//  import wxRespAdd from '@/views/wx/respAdd'
import wxRespAdd from '@/views/wx/respAddNew'
import wxRespAddDetails from '@/views/wx/respAddDetails'
import wxRespList from '@/views/wx/respList'
import wxRespDetails from '@/views/wx/respDetails'
import wxProfile from '@/views/wx/profile'
import wxSignfor from '@/views/wx/signfor'

// 前端路由表
const constantRouterComponents = {
  // 基础页面 layout 必须引入
  BasicLayout: BasicLayout,
  BlankLayout: BlankLayout,
  RouteView: RouteView,
  PageView: PageView,

  // 你需要动态引入的页面组件
  materielPricedetail: () => import('@/views/basic/MaterielPriceListdetail'), // 价格审批页面
  welcome: () => import('@/views/dashboard/Analysis'), // 欢迎页
  blackList: () => import('@/views/basic/BlackList'), // 黑名单管理
  bussinessType: () => import('@/views/basic/BussinessType'), // 业务类型管理
  card: () => import('@/views/basic/Card'), // 卡号管理
  corpBusiness: () => import('@/views/basic/CorpBusiness'), // 客户管理
  corpCompany: () => import('@/views//basic/CorpCompany'), // 使用企业管理
  corpLogistics: () => import('@/views/basic/CorpLogistics'), // 物流公司管理
  corpSupplier: () => import('@/views/basic/CorpSupplier'), // 供应商管理
  driver: () => import('@/views/basic/DriverList'), // 驾驶员管理
  // escort: () => import('@/views/list/TableList'), // 押运员管理
  escort: () => import('@/views/basic/escortList'), // 押运员管理
  factory: () => import('@/views/basic/Factory'), // 厂区管理
  factoryLoad: () => import('@/views/basic/FactoryLoad'), // 装卸货点管理
  factoryDoor: () => import('@/views/basic/FactoryDoor'), // 厂区管理
  materiel: () => import('@/views/basic/MaterielList'), // 物料管理
  materielGroup: () => import('@/views/basic/MaterielGroup'), // 物料分组管理
  materielLoadTime: () => import('@/views/basic/MaterielLoadTime'), // 物料分组管理
  materielBatch: () => import('@/views/basic/MaterielBatch'),
  materielPrice: () => import('@/views/basic/MaterielPriceList'), // 物料管理
  vehicle: () => import('@/views/basic/VehicleList'), // 车辆管理
  vehicleType: () => import('@/views/basic/VehicleTypeList'), // 车型管理
  queueCall: () => import('@/views/basic/QueueCallList'), // 厂外排队叫号
  queueCallFactory: () => import('@/views/basic/QueueCallListFactory'), // 厂内排队叫号
  weighingLimit: () => import('@/views/basic/WeighingLimit'), // 称重误差管理

  logistics: () => import('@/views/logistics/LogisticsList'), // 物流管理
  logisticsLog: () => import('@/views/logistics/LogisticsLog'), // 物流日志
  logisticsDoor: () => import('@/views/logistics/Door'), // 门禁记录管理
  grantCardOpen: () => import('@/views/logistics/GrantCardOpenBak2'), // 发卡记录管理
  grantCard: () => import('@/views/logistics/GrantCard'), // 发卡记录管理
  loadVehicle: () => import('@/views/logistics/LoadVehicle'), // 装卸货记录管理
  reservation: () => import('@/views/logistics/ReservationList'), // 预约记录管理
  weighing: () => import('@/views/logistics/WeighingList'), // 称重记录管理
  reservationAdd: () => import('@/views/logistics/ReservationAdd'), // 预约记录管理
 // reservationAdd_multi: () => import('@/views/logistics/ReservationAdd_multi'), // 预约记录管理
  reservationAdd_multi: () => import('@/views/logistics/ReservationAdd_multi_new'), // 预约记录管理
  assay: () => import('@/views/logistics/AssayList'), // 化验记录管理
  upload: () => import('@/views/logistics/Upload'), // 化验记录管理
  order: () => import('@/views/logistics/Order'), // 订单管理
  report: () => import('@/views/logistics/Report'), // 报表管理

  alarm: () => import('@/views/sys/log/Alarm'), // 报警记录管理
  log: () => import('@/views/sys/log/Log'), // 日志管理 
  weighingLog: () => import('@/views/sys/log/WeighingLog'), // 日志管理
  attachment: () => import('@/views/sys/attachment/Attachment'), // 附件管理
  code: () => import('@/views/sys/code/code'), // 字典管理
  codeType: () => import('@/views/sys/code/codeType'), // 字典类型管理
  menu: () => import('@/views/sys/menu/Menu'), // 菜单管理
  privilege: () => import('@/views/sys/privilege/Privilege'), // 功能点权限管理
  role: () => import('@/views/sys/role/Role'), // 角色管理
  roleWeiXin: () => import('@/views/sys/role/RoleWeiXin'), //  微信角色管理
  password: () => import('@/views/sys/user/ModifyPassword'), // 修改密码
  user: () => import('@/views/sys/user/UserList'), // 用户管理
  userOnline: () => import('@/views/sys/user/UserOnline'), // 在线用户管理
  terminal: () => import('@/views/sys/terminal/Terminal'), // 终端管理
  button: () => import('@/views/sys/button/WxButton'), //  微信按钮管理
  settings: () => import('@/views/sys/settings/settings'), //  微信按钮管理


  order_xs: () => import('@/views/order/OrderXs'), // 销售订单管理
  order_cg: () => import('@/views/order/OrderCg'), // 采购订单管理
  order_invoice: () => import('@/views/order/OrderXsInvoice'), // 销售订单开票管理
  order_receipt: () => import('@/views/order/OrderReceipt'), // 收款/充值管理
  order_biz_stats: () => import('@/views/order/OrderBizStats'), // 客户统计
  orderXs_export: () => import('@/views/order/OrderXsExport'), // 销售明细
}

// 前端未找到页面路由（固定不用改）
const notFoundRouter = {
  path: '*', redirect: '/404', hidden: true
}

/**
 * 获取后端路由信息的 axios API
 * @returns {Promise}
 */
export const getRouterByUser = (roles) => {
  return axios({
    url: '/Menu/treeByRole?roles=' + roles.roles,
    method: 'get'
    /* headers: {
      'Access-Token': 'xxx'
    }
    */
  })
}

/**
 * 获取路由菜单信息
 *
 * 1. 调用 getRouterByUser() 访问后端接口获得路由结构数组
 *    @see https://github.com/sendya/ant-design-pro-vue/blob/feature/dynamic-menu/public/dynamic-menu.json
 * 2. 调用
 * @returns {Promise<any>}
 */
export const generatorDynamicRouter = (roles) => {
  return new Promise((resolve, reject) => {
    // ajax
    getRouterByUser(roles).then(res => {
      if (res.code === '0') {
        const data = res.data
        const routers = [
          {
            path: '/',
            name: 'index',
            component: BasicLayout,
            meta: { title: '首页' },
            redirect: '/welcome',
            children: [
              {
                path: '/welcome',
                name: 'welcome',
                meta: { keepAlive: false },
                component: constantRouterComponents['welcome'],
                hidden: true
              }
            ]
          }
        ]

        if (data != null) {
          for (let i = 0, len = data.length; i < len; i++) {
            routers[0].children = routers[0].children.concat(generator([data[i]]))
          }
        }

        routers.push(notFoundRouter)
        resolve(routers)
      }
    }).catch(err => {
      reject(err)
    })
  })
}

export const generatorDynamicRouterForWx = (roles) => {
  const routers = [
    { path: '/wx', component: wxMain, name: 'wxMain', meta: { title: '微信首页' } },
    { path: '/wxRespAdd', component: wxRespAdd, name: 'wxRespAdd', meta: { title: '微信预约登记' } },
    { path: '/wxRespAddDetails', component: wxRespAddDetails, name: 'wxRespAddDetails', meta: { title: '微信预约登记详情' } },
    { path: '/wxRespList', component: wxRespList, name: 'wxRespList', meta: { title: '微信预约记录' } },
    { path: '/wxRespDetails', component: wxRespDetails, name: 'wxRespDetails', meta: { title: '微信预约详情' } },
    { path: '/wxProfile', component: wxProfile, name: 'wxProfile', meta: { title: '微信个人信息' } },
    { path: '/wsSignfor', component: wxSignfor, name: 'wsSignfor', meta: { title: '签收' } },
    { path: '/wxCorpBusiness', component: wxCorpBusiness, name: 'wxCorpBusiness', meta: { title: '客户收款' } },
    { path: '/wxOrderReceipt', component: wxOrderReceipt, name: 'wxOrderReceipt', meta: { title: '客户收款审核' } }


  ]
  return routers
}
/**
 * 格式化 后端 结构信息并递归生成层级路由表
 *
 * @param routerMap
 * @param parent
 * @returns {*}
 */
export const generator = (routerMap, parent) => {
  return routerMap.map(item => {
    const currentRouter = {
      // 路由地址 动态拼接生成如 /dashboard/workplace
      path: `${parent && parent.path || ''}/${item.url}`,
      // 路由名称，建议唯一
      name: item.url || '',
      // 该路由对应页面的 组件
      component: item.children && item.children.length > 0 ? constantRouterComponents['RouteView'] : constantRouterComponents[item.url],
      // meta: 页面标题, 菜单图标, 页面权限(供指令权限用，可去掉) // , permission: item.key && [ item.key ] || null
      meta: { title: item.name, icon: item.ico || undefined }
    }
    // 为了防止出现后端返回结果不规范，处理有可能出现拼接出两个 反斜杠
    currentRouter.path = currentRouter.path.replace('//', '/')
    // 重定向
    // item.redirect && (currentRouter.redirect = item.redirect)
    // 是否有子菜单，并递归处理
    if (item.children && item.children.length > 0) {
      // Recursion
      currentRouter.children = generator(item.children, currentRouter)
    }
    return currentRouter
  })
}
